import React from 'react';
import { Plus, MoreVertical, Search, Filter } from 'lucide-react';
import { Link } from 'react-router-dom';
import { properties, formatNaira } from '../../../data/mockData';
import { VerificationBadge, TierBadge } from '../../../components/shared/Badges';
export const SellerListings = () => {
  return <div className="space-y-6 animate-in fade-in" data-id="element-1422">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-1423">
        <div data-id="element-1424">
          <h1 className="text-2xl font-serif font-bold text-primary-900 mb-1" data-id="element-1425">
            My Listings
          </h1>
          <p className="text-text-light" data-id="element-1426">Manage your property portfolio.</p>
        </div>
        <Link to="/list-property" className="bg-secondary hover:bg-secondary-dark text-white px-5 py-2.5 rounded-lg text-sm font-bold transition-colors shadow-glow flex items-center gap-2" data-id="element-1427">
          <Plus size={18} data-id="element-1428" /> New Listing
        </Link>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-neutral-200 overflow-hidden" data-id="element-1429">
        {/* Toolbar */}
        <div className="p-4 border-b border-neutral-200 flex flex-col sm:flex-row gap-4 justify-between items-center bg-neutral-50" data-id="element-1430">
          <div className="flex gap-2 overflow-x-auto w-full sm:w-auto pb-2 sm:pb-0 custom-scrollbar" data-id="element-1431">
            <button className="px-4 py-1.5 rounded-lg bg-primary-900 text-white text-sm font-bold whitespace-nowrap" data-id="element-1432">
              All (6)
            </button>
            <button className="px-4 py-1.5 rounded-lg bg-white border border-neutral-200 text-text text-sm font-medium hover:bg-neutral-50 whitespace-nowrap" data-id="element-1433">
              Active (4)
            </button>
            <button className="px-4 py-1.5 rounded-lg bg-white border border-neutral-200 text-text text-sm font-medium hover:bg-neutral-50 whitespace-nowrap" data-id="element-1434">
              Pending (1)
            </button>
            <button className="px-4 py-1.5 rounded-lg bg-white border border-neutral-200 text-text text-sm font-medium hover:bg-neutral-50 whitespace-nowrap" data-id="element-1435">
              Rejected (1)
            </button>
          </div>
          <div className="flex gap-2 w-full sm:w-auto" data-id="element-1436">
            <div className="relative flex-grow sm:w-64" data-id="element-1437">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-dark" size={16} data-id="element-1438" />
              <input type="text" placeholder="Search listings..." className="w-full pl-9 pr-4 py-2 rounded-lg border border-neutral-200 text-sm outline-none focus:ring-2 focus:ring-primary-900" data-id="element-1439" />
            </div>
            <button className="p-2 border border-neutral-200 rounded-lg text-text hover:bg-neutral-50" data-id="element-1440">
              <Filter size={18} data-id="element-1441" />
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto" data-id="element-1442">
          <table className="w-full text-left border-collapse min-w-[800px]" data-id="element-1443">
            <thead data-id="element-1444">
              <tr className="bg-white text-xs font-bold text-text-light uppercase tracking-wider border-b border-neutral-200" data-id="element-1445">
                <th className="p-4 pl-6" data-id="element-1446">Property</th>
                <th className="p-4" data-id="element-1447">Status</th>
                <th className="p-4" data-id="element-1448">Tier</th>
                <th className="p-4" data-id="element-1449">Price</th>
                <th className="p-4" data-id="element-1450">Metrics</th>
                <th className="p-4" data-id="element-1451">Date Added</th>
                <th className="p-4 pr-6 text-right" data-id="element-1452">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-neutral-100" data-id="element-1453">
              {properties.map(p => <tr key={p.id} className="hover:bg-neutral-50 transition-colors bg-white" data-id="element-1454">
                  <td className="p-4 pl-6" data-id="element-1455">
                    <div className="flex items-center gap-3" data-id="element-1456">
                      <img src={p.images[0]} alt="" className="w-12 h-12 rounded-lg object-cover" data-id="element-1457" />
                      <div data-id="element-1458">
                        <div className="font-bold text-sm text-text line-clamp-1" data-id="element-1459">
                          {p.title}
                        </div>
                        <div className="text-xs text-text-light" data-id="element-1460">
                          {p.district}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="p-4" data-id="element-1461">
                    <VerificationBadge status={p.verificationStatus as any} data-id="element-1462" />
                  </td>
                  <td className="p-4" data-id="element-1463">
                    <TierBadge tier={p.tier as 1 | 2 | 3} data-id="element-1464" />
                  </td>
                  <td className="p-4 font-medium text-sm text-text" data-id="element-1465">
                    {formatNaira(p.price)}
                  </td>
                  <td className="p-4" data-id="element-1466">
                    <div className="text-xs text-text-light" data-id="element-1467">
                      <span className="font-bold text-text" data-id="element-1468">
                        {Math.floor(Math.random() * 500) + 100}
                      </span>{' '}
                      views
                      <br data-id="element-1469" />
                      <span className="font-bold text-text" data-id="element-1470">
                        {Math.floor(Math.random() * 20)}
                      </span>{' '}
                      inquiries
                    </div>
                  </td>
                  <td className="p-4 text-sm text-text-light" data-id="element-1471">Oct 12, 2023</td>
                  <td className="p-4 pr-6 text-right" data-id="element-1472">
                    <button className="p-2 text-text-light hover:text-text rounded-lg hover:bg-neutral-200 transition-colors" data-id="element-1473">
                      <MoreVertical size={18} data-id="element-1474" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};